/**
* Collection grid color swatches: keyboard-operable variant switching
* (Enter/Space to select, arrow keys / Home / End to move within the group).
*/
(function () {
  var SWATCH_SEL = '.boost-pfs-filter-item-swatch-span';
  var GROUP_SEL = '.boost-pfs-filter-item-swatch';
  var COLLECTION_GRID_ID = 'main-collection-product-grid';


  function isInCollectionGrid(el) {
    return !!(el && el.closest && el.closest('#' + COLLECTION_GRID_ID));
  }


  function getSwatches(ul) {
    if (!ul) return [];
    return Array.prototype.slice.call(ul.querySelectorAll(SWATCH_SEL));
  }


  function syncSwatchGroup(ul) {
    if (!ul) return;
    var swatches = getSwatches(ul);
    if (!swatches.length) return;


    if (!ul.getAttribute('role')) {
      ul.setAttribute('role', 'radiogroup');
      var match = ul.className.match(/boost-pfs-filter-item-swatch-option-(\S+)/);
      if (match && match[1] && !ul.getAttribute('aria-label')) {
        ul.setAttribute('aria-label', match[1]);
      }
    }


    var inCollectionGrid = isInCollectionGrid(ul);


    for (var i = 0; i < swatches.length; i++) {
      var swatch = swatches[i];
      var isActive = swatch.classList.contains('active');
      if (!swatch.getAttribute('role')) {
        swatch.setAttribute('role', 'radio');
      }
      swatch.setAttribute('aria-checked', isActive ? 'true' : 'false');
      if (!inCollectionGrid) {
        swatch.setAttribute('tabindex', isActive ? '0' : '-1');
      }
    }


    if (inCollectionGrid && window.MG_BOOST_PFS_FILTER_GRID_TABORDER_A11Y) {
      window.MG_BOOST_PFS_FILTER_GRID_TABORDER_A11Y.refresh();
    }
  }


  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(GROUP_SEL).forEach(syncSwatchGroup);
  }


  function onKeydown(e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches(SWATCH_SEL)) return;


    var ul = el.closest(GROUP_SEL);
    var swatches = getSwatches(ul);
    var index = swatches.indexOf(el);
    if (index === -1) return;


    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      el.click();
      return;
    }


    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;


    e.preventDefault();
    var next = index;
    if (e.key === 'ArrowRight') next = (index + 1) % swatches.length;
    else if (e.key === 'ArrowLeft') next = (index - 1 + swatches.length) % swatches.length;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = swatches.length - 1;


    var target = swatches[next];
    if (target && target !== el) {
      target.click();
      target.focus();
    }
  }


  document.addEventListener('keydown', onKeydown, false);


  document.addEventListener(
    'click',
    function (e) {
      var el = e.target && e.target.closest ? e.target.closest(SWATCH_SEL) : null;
      if (!el) return;
      syncSwatchGroup(el.closest(GROUP_SEL));
    },
    false
  );


  var debounceTimer;
  function scheduleScan(target) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      if (target && target.nodeType === 1) {
        if (target.matches && target.matches(GROUP_SEL)) syncSwatchGroup(target);
        scan(target);
      } else {
        scan(document);
      }
    }, 0);
  }


  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'childList' && m.addedNodes && m.addedNodes.length) {
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType === 1) scheduleScan(n);
        }
      }
      if (m.type === 'attributes' && m.target && m.target.nodeType === 1) {
        var t = m.target;
        if (t.matches && t.matches(SWATCH_SEL)) {
          syncSwatchGroup(t.closest(GROUP_SEL));
        }
      }
    }
  });


  function startObserver() {
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
      startObserver();
    });
  } else {
    scan(document);
    startObserver();
  }


  window.addEventListener('load', function () {
    scheduleScan(document.documentElement);
  });


  document.addEventListener('collectionLoad', function () {
    scheduleScan(document.documentElement);
  });


  [400, 2000, 4500].forEach(function (ms) {
    setTimeout(function () {
      scheduleScan(document.documentElement);
    }, ms);
  });


  window.MG_BOOST_PFS_FILTER_SWATCHES_A11Y = {
    refresh: function () {
      scheduleScan(document.documentElement);
    }
  };
 })();